import React from "react";
import { Routes, Route } from "react-router-dom";

import ReportsPage from "./Pages/ReportsPage";
import PodcastPage from "./Pages/PodcastsPage";
import BlogPage from "./Pages/BlogPage";
import BlogDetailsPage from "./Pages/BlogDetails";
import AboutPage from "./Pages/AboutPage";
import HomePage from "./components/Home";
import ReportDetailsPage from "./Pages/ReportsDetails";
import VideoPage from "./Pages/PodcastDetails";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/real-estate-reports" element={<ReportsPage />} />
      <Route path="/report/:id" element={<ReportDetailsPage />} />
      <Route path="/podcasts" element={<PodcastPage />} />
      <Route path="/podcast/:podcastId" element={<VideoPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:id" element={<BlogDetailsPage />} />
      <Route path="/about" element={<AboutPage />} />
    </Routes>
  );
}

export default AppRoutes;
